import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contains', standalone: true })
export class ContainsPipe implements PipeTransform {
  transform(array: string[], token: string): boolean {
    return array.some((str) => str === token);
  }
}
